{
  "page": {
    "title": "評分規準",
    "description": "權重總和必須為 100。若編輯已有評分紀錄的規準，系統會自動建立新版本。",
    "create": {
      "title": "新增評分規準",
      "description": "先建立一個滿分 100 的評分項目，之後可透過規準編輯器進一步調整。",
      "namePlaceholder": "規準名稱",
      "defaultItemName": "整體評分",
      "submit": "新增",
      "failed": "無法建立評分規準。",
      "created": "已建立評分規準。"
    }
  },
  "editor": {
    "loading": "載入中…",
    "empty": "尚無評分規準。",
    "description": "權重總和必須為 100。若此規準已有評分紀錄，儲存時會複製為新版本，不會更動已完成的評分。",
    "versionLabel": "版本名稱",
    "versionLabelPlaceholder": "例如：初賽、決賽",
    "versionLabelSave": "儲存版本名稱",
    "versionLabelSaved": "版本名稱已更新。",
    "versionLabelFailed": "無法更新版本名稱。",
    "name": "名稱",
    "namePlaceholder": "評分項目名稱",
    "itemDescription": "定義說明（選填）",
    "itemDescriptionPlaceholder": "說明此項目的評分標準與表現描述，協助評審間標準一致",
    "anchors": {
      "title": "分數級距範例（選填）",
      "help": "寫出各分數區間的判斷標準與例子，評審評分時可展開查看，能降低評審之間的落差。",
      "min": "級距最低分",
      "max": "級距最高分",
      "description": "級距說明",
      "placeholder": "例如：傑出，內容完整且具原創性",
      "add": "新增級距",
      "remove": "移除"
    },
    "weight": "權重（%）",
    "scoreRange": "分數範圍",
    "minScore": "最低分",
    "maxScore": "最高分",
    "remove": "移除",
    "addCriterion": "新增評分項目",
    "moveUp": "上移",
    "moveDown": "下移",
    "scaleNote": "總分以 100 分為滿分：每個評分項目依「得分 ÷ 該項最高分 × 權重」換算，所以各項目用 0 到 10 或 0 到 100 計分都可以，也可以彼此不同。",
    "totalWeightValid": "權重總和：{{total}}%（有效）",
    "totalWeightInvalid": "權重總和：{{total}}%（必須等於 100%）",
    "save": "儲存變更",
    "saving": "儲存中…",
    "saved": "評分規準已更新。",
    "saveFailed": "無法儲存評分規準。"
  }
}
